module.exports = false;



//////////////////
// WEBPACK FOOTER
// ../~/babel-polyfill/~/core-js/modules/_library.js
// module id = 133
// module chunks = 1